import { Link, useNavigate, useRouteData } from "@solidjs/router";
import { createEffect, createMemo, onMount, Show } from "solid-js";
import type { Component } from "solid-js";
import IssuersList from "~/components/IssuersList";
import PageSection from "~/components/PageSection";
import { createQuery } from "~/components/RPCProvider";

export const routeData = () => createQuery("getAccountInfo", undefined);

export const Dashboard: Component = () => {
  const [accountInfo] = useRouteData<typeof routeData>();
  const navigate = useNavigate();
  const issuers = createMemo(() => accountInfo.latest?.issuers ?? []);
  createEffect(() => {
    console.debug({ accountInfo: accountInfo(), issuers: issuers() });
  });

  onMount(async () => {
    //TODO add AADE role as a variable in config file
    if (accountInfo()?.userRole == "AADE") {
      navigate("/invoices");
    }
  });

  return (
    <PageSection>
      <Show when={issuers().length >= 1} fallback={<NoIssuerWarningCard />}>
        <h1 class="ms-3 mb-3 mt-3">
          {issuers().length === 1 ? "Εκδότης " : "Eκδότες "} παραστατικών
        </h1>
        <IssuersList issuers={issuers()} />
      </Show>
    </PageSection>
  );
};
export default Dashboard;

const NoIssuerWarningCard = () => (
  <div class="d-flex container-fluid justify-content-center mobile-w100per">
    <div class="ms-5 me-5 card bg-warning container-fluid primary-color-bg no-margin">
      <div class="card-header p-3">
        <h5 class="card-title mb-3 text-light">
          Δεν έχουν καταχωριστεί στοιχεία εκδότη παραστατικών.
        </h5>
        <div class="card-body">
          <Link
            class="btn btn-primary p-2 mobile-w100per"
            href="/dashboard/issuers/register"
          >
            Προσθήκη εκδότη
          </Link>
        </div>
      </div>
    </div>
  </div>
);
